import React from "react";
import { connect } from "react-redux";

import { getFeriados, eliminarFeriado } from "./FeriadoService.js";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";

import NavbarConfiguraciones from "../componentes/NavbarConfiguraciones.js";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion.js";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";

// Si querés el botón "ver" como en Usuarios, acá podés abrir un modal o navegar a una pantalla.
// Por ahora lo hago navegando a /configuracion/feriados/ver (podés ajustar la ruta).
class Feriados extends React.Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    const anioActual = new Date().getFullYear();

    this.state = {
      elementoSeleccionado: null,

      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",

      ventanaEliminar: false,
      openPantallaCarga: false,

      // filtro simple por año (si no lo querés, borralo)
      anio: estado.anio || anioActual,
    };

    this.tablaRef = React.createRef();
    this.modalEliminarRef = React.createRef();
  }

  handleEditarDatos = (dato) => {
    this.props.history.push({
      pathname: "/configuracion/feriados/edit",
      state: { feriado: dato },
    });
  };

  handleVerDatos = (dato) => {
    this.props.history.push({
      pathname: "/configuracion/feriados/ver",
      state: { feriado: dato },
    });
  };

  abrirModalEliminar = (estado, feriado = null) => {
    this.setState({
      ventanaEliminar: estado,
      elementoSeleccionado: feriado,
    });
  };

  cerrarModalEliminar = () => {
    this.setState({ ventanaEliminar: false });
  };

  eliminar = () => {
    this.modalEliminarRef?.cerrarModalConAnimacion?.();
    this.setState({ openPantallaCarga: true });

    const feriado = this.state.elementoSeleccionado;

    this.props.eliminarFeriado(feriado.id).then((response) => {
      this.setState({
        openPantallaCarga: false,
        mostrarMensajeFlash: true,
        mensajeFlash: response?.mensaje || "Feriado eliminado",
        mensajeFlashSeverity: response?.error ? "error" : "exito",
      });
      this.actualizarDatosTabla();
    });
  };

  fetchFeriados = (page, pageSize, search) => {
    // getFeriados(page, size, anio, search) como lo armamos antes
    return this.props.getFeriados(page, pageSize, this.state.anio, search).then(() => {
      const { feriadosData } = this.props;
      console.log("Feriados obtenidos:", feriadosData);
      return {
        items: feriadosData.feriados,
        totalCount: feriadosData.totalCount,
      };
    });
  };

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.id}>
        <td>{f.dia}</td>
        <td>{f.mes}</td>
        <td>{f.anio}</td>
        <td>{f.descripcion}</td>
        <td>
          <div className="table-actions">
            <button className="table-icon open-dialog" onClick={() => this.handleEditarDatos(f)}>
              <span className="material-symbols-outlined"> edit </span>
            </button>
            <button
              className="table-icon open-dialog"
              data-dialog="modal-delete-details"
              onClick={() => this.abrirModalEliminar(true, f)}
            >
              <span className="material-symbols-outlined"> delete </span>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  };

  render() {
    return (
      <div>
        <div className="template-base">
          <PantallaCarga open={this.state.openPantallaCarga} />

          <NavbarConfiguraciones
            titulo={"Feriados"}
            descripcion={"Gestione los feriados del sistema"}
            textoBoton={"Nuevo Feriado"}
            direccionBoton={"/configuracion/feriados/nuevo"}
          />

          <div className="wrapperContent">
            <div className="page-container">
              {/* Si querés el filtro año, dejalo. Si no, borrá este bloque */}
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12 }}>
                <span className="label">Año</span>
                <input
                  className="input-base"
                  type="number"
                  value={this.state.anio}
                  onChange={(e) => this.setState({ anio: e.target.value }, this.actualizarDatosTabla)}
                  style={{ width: 120 }}
                />
              </div>

              <TablaItemsConfiguracion
                ref={(ref) => (this.tablaRef = ref)}
                titulo="Feriados disponibles"
                headers={["Día", "Mes", "Año", "Descripción", "Acciones"]}
                fetchDatos={this.fetchFeriados}
                renderFilas={this.renderFilas}
              />
            </div>

            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity}
            />
          </div>

          <ModalEliminarConDetalles
            ref={(ref) => (this.modalEliminarRef = ref)}
            isOpen={this.state.ventanaEliminar}
            cerrarModal={this.cerrarModalEliminar}
            onConfirmar={this.eliminar}
            elemento={this.state.elementoSeleccionado}
            titulo="feriado"
            detallesAMostrar={[
              { clave: "dia", etiqueta: "Día" },
              { clave: "mes", etiqueta: "Mes" },
              { clave: "anio", etiqueta: "Año" },
              { clave: "descripcion", etiqueta: "Descripción" },
            ]}
            mensaje="Esta acción eliminará permanentemente el elemento"
            textoBotonAccion="CONFIRMAR ELIMINACIÓN"
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getFeriados: (page, size, anio, search) => dispatch(getFeriados(page, size, anio, search)),
  eliminarFeriado: (id) => dispatch(eliminarFeriado(id)),
});

const mapStateToProps = (state) => ({
  feriadosData: state.feriadosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Feriados);
